import * as angular from 'angular';
import {IController} from "angular";

export class AdditionsMultiSelectListComponent implements IController {
  additions: any;
  options: any;
  ngPlaceholder: any;
  onChange: Function;

  public queryString: any;
  private additionsCountMap: any;

  constructor() {
  }

  $onInit() {
    this._setAdditionsCountMap();
  }

  $onChanges(changes) {
    if (changes.additions) {
      this._setAdditionsCountMap();
    }
  }


  onToggle(option) {
    let additions;
    if (this.additionsCountMap[option.id]) {
      additions = this.additions.filter(a => a.id !== option.id);
    } else {
      additions = angular.copy(this.additions);
      additions.push(option);
    }
    this.onChange({additions: additions});
  }

  onCountChange(count, option) {
    let additions = this.additions.filter(a => a.id !== option.id);
    if (count !== null && count !== undefined) {
      for (let i = 1; i <= count; i++) {
        additions.push(option);
      }
    }

    this.onChange({additions: additions});
  }

  onReset() {
    this.onChange({additions: []});
  }

  submitQuery(query) {
    this.queryString = query;
  }

  private _setAdditionsCountMap() {
    this.additionsCountMap = {};
    this.additions?.forEach(a => {
      if (!this.additionsCountMap[a.id]) {
        this.additionsCountMap[a.id] = 0;
      }
      this.additionsCountMap[a.id] = this.additionsCountMap[a.id] + 1;
    })
  }

}

angular
  .module('bringoz.admin.commons')
  .component('additionsMultiSelectList', {
    bindings: {
      additions: '<',
      options: '<?',
      ngPlaceholder: '@?',
      onChange: '&'
    },
    template: require('./additions-multi-select-list.html').default,
    controller: AdditionsMultiSelectListComponent
  });
